import { setGame, setGroup } from "../redux/actions";
import { ROUTES } from "./constants";
import { clearItem, clearLastTick } from "./helpers";
import { clearErPlaySession } from "./erPlaySessionStorage";

/** Id del juego enlazado al grupo (ObjectId string), estable para dependencias de efectos. */
export function groupLinkedGameId(group) {
	const g = group?.game;
	if (g == null || g === "") return "";
	return typeof g === "object" && g._id != null ? String(g._id) : String(g);
}

/**
 * Limpia Redux + localStorage de partida y vuelve a introducir código.
 * Útil cuando el juego ya no está activo, el backend responde 4xx/5xx o hay estado inconsistente.
 */
export function resetPlaySessionToEnterCode(dispatch, navigate) {
	try {
		dispatch(setGame(null));
		dispatch(setGroup(null));
	} catch (_) {
		// no-op
	}
	clearErPlaySession();
	clearItem("groupTable");
	clearItem("total");
	clearLastTick();
	try {
		localStorage.removeItem("erRegisterReturnIndex");
		localStorage.removeItem("erForceRegisterFlow");
	} catch (_) {}
	if (typeof navigate === "function") {
		navigate(ROUTES.ENTER_CODE, { replace: true });
	}
}
